import { useState, useEffect } from 'react'
import { Dimensions, Platform } from 'react-native'

const getCurrentScreenSize = () => {
  if (Platform.OS === 'web') {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  } else {
    const { width, height } = Dimensions.get('window')
    return { width, height }
  }
}

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState(getCurrentScreenSize())

  useEffect(() => {
    const handleResize = (event: any) => {
      if (Platform.OS === 'web') {
        setScreenSize({
          width: window.innerWidth,
          height: window.innerHeight,
        })
      } else {
        const { width, height } = event.window
        setScreenSize({ width, height })
      }
    }

    if (Platform.OS === 'web') {
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    } else {
      const subscription = Dimensions.addEventListener('change', handleResize)
      return () => subscription?.remove?.()
    }
  }, [])

  return screenSize
}

export default useScreenSize
